const newFeature = {
  title: 'Noticias del blog',
  caption: 'Tips y consejos',
  linkLabel: 'Leer en el blog',
}

export default newFeature
